import { type AiAgentTemplateResponse } from './types';
import { some } from 'lodash';

const planMap = {
  rpre: window.currentAccount?.roadmapFlavor,
  iess: window.currentAccount?.ideasFlavor,
  dess: window.currentAccount?.discoveryFlavor,
  wess: window.currentAccount?.whiteboardsFlavor,
  wadv: window.currentAccount?.whiteboardsAdvanced,
  kess:
    window.currentAccount?.knowledgeFlavor ||
    window.currentAccount?.ideasFlavor,
  kadv: window.currentAccount?.knowledgeAdvanced,
  dev: window.currentAccount?.teamworkOrDevelopFlavor,
};

function globalTemplatesUrl() {
  return `${window.Configatron?.secureUrlBase}/global_ai_agent_templates/graphql`;
}

export const getGlobalTemplates = async () => {
  const result = (await $.post(globalTemplatesUrl(), {
    query: `{
        aiUserAgents {
          id
          name
          agentType
          capabilities
          categories
          plans
          agentScope
          description
          shortDescription
          longDescription
          createdAt
          markdownInstruction
          guideDescription
          thumbnail
          slug
        }
      }`,
  }).catch(error => {
    console.error('Error fetching global templates');
    console.error(JSON.stringify(error));
    throw new Error('Failed to load templates');
  })) as { data: { aiUserAgents: { nodes: AiAgentTemplateResponse[] } } };

  // Normalize global templates to match graphql api
  // @ts-ignore
  const globalTemplates = result.data.aiUserAgents.nodes
    .filter(template => {
      return (
        // Fail open if no plans are set/we get null/undefined
        !template.plans ||
        // Roadmaps can always see all templates
        window?.currentAccount?.roadmapFlavor ||
        some(template.plans.map(plan => planMap[plan]))
      );
    })
    .map(template => {
      return {
        ...template,
      } as AiAgentTemplateResponse;
    });

  return globalTemplates;
};
